"use strict";

var _preact = require("preact");

module.exports = function (_ref) {
  var currentDeviceId = _ref.currentDeviceId,
      audioSources = _ref.audioSources,
      onChangeSource = _ref.onChangeSource;
  return (0, _preact.h)("div", {
    className: "uppy-Audio-videoSource"
  }, (0, _preact.h)("select", {
    className: "uppy-u-reset uppy-Audio-audioSource-select",
    onChange: function onChange(event) {
      onChangeSource(event.target.value);
    }
  }, audioSources.map(function (audioSource) {
    return (0, _preact.h)("option", {
      key: audioSource.deviceId,
      value: audioSource.deviceId,
      selected: audioSource.deviceId === currentDeviceId
    }, audioSource.label);
  })));
};